import React from 'react';
import i18n from '../../i18n';
import {isInteger, withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, number, boolean, required, mixed, max} from "yup";
import AppointmentFormFields from './AppointmentFormFields'

class AppointmentForm extends React.Component {

    render() {
        const {
            values,
            customer,
            machines,
        } = this.props;


        return <AppointmentFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            customer_id: props.customer.id,
            appointment_name: '',
            project_number: '',
            day_last_appointment: '',
            day_next_appointment: '',
            remember: '',
            days_before_remember: '',
            technician_id: '',
            interval: '',
            machine_id: '',
            machines: [],
        });
    },

    validationSchema: () => {
        let rules = object().shape({
            appointment_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.appointment_name')})
            ),
            project_number: number().max(
                99999999999, i18n.get('validation.max.string', {attribute: i18n.get('appointments.project_number'), max: 11})
            ),
            day_last_appointment: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.day_last_appointment')})
            ),
            day_next_appointment: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.day_next_appointment')})
            ),
            technician_id: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.technician_id')})
            ),
            interval: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.interval')})
            ),
            machine_id: string().required(
                i18n.get('validation.required', {attribute: i18n.get('appointments.machine_id')})
            ),
        });

        return rules
    },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            // swal({
            //     icon: "success",
            //     title: i18n.get('cooperations.save_success'),
            //     text: i18n.get('cooperations.you_will_be_redirected'),
            //     timer: 4000,
            // }).then(() => {
                window.location.href = props.redirectAfterSubmit
            // })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('appointments.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(AppointmentForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Appointments/AppointmentForm.js